var React = require('react');

function MedicalReport (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"0","strokeWidth":"4","strokeLinecap":"round","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M55 54.203h-6.194V48h-8.603v6.203H34v8.594h6.203V69h8.603v-6.203H55zM78 42.5h9M78 50.5h9M78 66.5h9M78 74.5h9M78 82.5h9","key":0}),React.createElement("path",{"d":"M22 27h43v61H22z","key":1}),React.createElement("path",{"d":"M65.233 36H92v61H49v-9.07M65 88l-16 9","key":2})]));
}

MedicalReport.defaultProps = {"width":"114","height":"114"};

module.exports = MedicalReport;

MedicalReport.default = MedicalReport;
